var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.448 13.9521L12.7715 13.9453C10.4057 13.9453 8.43901 15.8161 8.377 18.2206C8.37507 18.2845 8.42835 18.3378 8.49229 18.3378L17.1688 18.3436C19.5346 18.3446 21.5013 16.4739 21.5633 14.0703C21.5652 14.0063 21.5119 13.9531 21.448 13.9531V13.9521Z",
    fill: "#E61A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8463 7.36616L12.7715 7.35938C10.4057 7.35938 8.43901 9.23012 8.377 11.6347C8.37507 11.6986 8.42835 11.7519 8.49229 11.7519L21.5672 11.7577C23.933 11.7587 25.8996 9.88793 25.9616 7.48435C25.9636 7.42041 25.9103 7.36713 25.8463 7.36713V7.36616Z",
    fill: "#E61A59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9912 24.8641C12.1838 24.6344 12.9645 23.4814 12.7348 22.2887C12.5052 21.0961 11.3521 20.3154 10.1595 20.5451C8.96684 20.7748 8.18618 21.9278 8.41585 23.1204C8.64552 24.3131 9.79854 25.0937 10.9912 24.8641Z",
    fill: "#E61A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlare);
export default __webpack_public_path__ + "static/media/flare.9729d338616321d31276fac5d4692d46.svg";
export { ForwardRef as ReactComponent };